/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

export const checkEndpointUpdatePending = async ({ endpointId }: { endpointId: string }) => {
  // TODO: check endpoint update pending

  return false;
};
